(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["starting-point-quiz"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-starting-point-quiz]');
    const recommendations = {
      real_event: { title: 'Start with the Real Event OCD guides', body: 'Your answers point to getting pulled back into the past and needing certainty about what happened or what it means. These guides are the most focused place to begin.', link: '/collections/real-event-ocd', label: 'Explore Real Event OCD guides' },
      relationship: { title: 'Start with Relationship OCD guides', body: 'Your answers point to relationship doubt, checking your feelings, or needing reassurance. These guides focus on that familiar loop.', link: '/collections/relationship-ocd-rocd', label: 'Explore Relationship OCD guides' },
      contamination: { title: 'Start with Contamination OCD guides', body: 'Your answers point to concerns around germs, washing, avoidance, or things feeling contaminated. These guides are designed for that pattern.', link: '/collections/contamination-ocd', label: 'Explore Contamination OCD guides' },
      harm: { title: 'Start with Harm OCD guides', body: 'Your answers point to distress around unwanted harm thoughts and the urge to get certainty about them. These guides give you a focused place to start.', link: '/collections/harm-ocd', label: 'Explore Harm OCD guides' },
      checking: { title: 'Start with Checking OCD guides', body: 'Your answers point to checking, rereading, retracing, or the feeling that you need to be certain. These guides are the closest match.', link: '/collections/checking-ocd', label: 'Explore Checking OCD guides' },
      rumination: { title: 'Start with Rumination & overthinking guides', body: 'Your answers point to a lot of mental replaying and trying to solve the thought in your head. These guides are built for that kind of loop.', link: '/collections/pure-o-rumination', label: 'Explore Rumination guides' },
      health: { title: 'Start with Health OCD guides', body: 'Your answers point to illness fears, symptom searching, or body checking. These guides are the closest fit.', link: '/collections/health-ocd', label: 'Explore Health OCD guides' },
      intrusive: { title: 'Start with Intrusive Thoughts guides', body: 'You do not need the perfect label to begin. These guides are a good first stop for unwanted thoughts, uncertainty, and mental loops.', link: '/collections/intrusive-thoughts', label: 'Explore Intrusive Thoughts guides' }
    };
    roots.forEach((root) => {
      const answers = {};
      let currentStep = 1;
      let goal = 'focused';
      const steps = root.querySelectorAll('[data-quiz-step]');
      const result = root.querySelector('[data-quiz-result]');
      const showStep = (step) => {
        currentStep = step;
        steps.forEach((item) => { const active = Number(item.dataset.quizStep) === step; item.hidden = !active; item.classList.toggle('is-active', active); });
        root.querySelectorAll('[data-quiz-step-indicator]').forEach((item) => item.classList.toggle('is-active', Number(item.dataset.quizStepIndicator) === step));
      };
      const publishEvent = (name, detail = {}) => {
        const safeDetail = { funnel: 'guide_finder', ...detail };
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: name, ...safeDetail });
        try {
          if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') window.Shopify.analytics.publish(name, safeDetail);
        } catch (error) {}
        try {
          if (typeof window.fbq === 'function') window.fbq('trackCustom', name, safeDetail);
        } catch (error) {}
      };
      const calculateScores = () => {
        const scores = {};
        Object.values(answers).forEach((value) => value.split(',').forEach((entry) => { const [key, points] = entry.split(':'); scores[key] = (scores[key] || 0) + Number(points); }));
        return scores;
      };
      const finish = () => {
        const scores = calculateScores();
        const key = Object.keys(recommendations).reduce((best, candidate) => (scores[candidate] || 0) > (scores[best] || 0) ? candidate : best, 'intrusive');
        const pick = goal === 'library' ? { title: 'The Complete OCD Library is your best fit', body: 'You chose broader coverage. This library gives you nine focused printable guides in one download, so you can explore more than one pattern without having to guess perfectly.', link: '/products/the-complete-ocd-subtype-library-9-workbooks', label: 'See the Complete OCD Library' } : goal === 'learn' ? { title: 'Start by exploring what feels familiar', body: 'You chose to learn first. This quick guide explains common patterns in plain English, then you can decide which resource feels right.', link: '/pages/learn', label: 'Explore what feels familiar' } : recommendations[key];
        root.querySelector('[data-quiz-result-title]').textContent = pick.title;
        root.querySelector('[data-quiz-result-body]').textContent = pick.body;
        const link = root.querySelector('[data-quiz-result-link]');
        link.href = pick.link;
        link.textContent = pick.label;
        steps.forEach((item) => { item.hidden = true; });
        result.hidden = false;
        publishEvent('guide_finder_completed', { result_path: goal });
      };
      root.querySelectorAll('[data-quiz-answer]').forEach((button) => button.addEventListener('click', () => { if (currentStep === 1 && !answers[1]) publishEvent('guide_finder_started'); answers[currentStep] = button.dataset.quizAnswer; showStep(currentStep + 1); }));
      root.querySelectorAll('[data-quiz-goal]').forEach((button) => button.addEventListener('click', () => { goal = button.dataset.quizGoal; finish(); }));
      root.querySelectorAll('[data-quiz-back]').forEach((button) => button.addEventListener('click', () => showStep(Math.max(1, currentStep - 1))));
      root.querySelector('[data-quiz-result-link]').addEventListener('click', () => publishEvent('guide_finder_recommendation_clicked', { result_path: goal }));
      root.querySelector('[data-quiz-library-link]').addEventListener('click', () => publishEvent('guide_finder_library_clicked'));
      root.querySelector('[data-quiz-restart]').addEventListener('click', () => { Object.keys(answers).forEach((key) => delete answers[key]); goal = 'focused'; result.hidden = true; showStep(1); });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
